import { Spin, SpinProps } from 'antd'

export interface SpinnerProps extends Omit<SpinProps, 'size'> {
  size?: 'sm' | 'md' | 'lg'
  color?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger'
  label?: string
  className?: string
}

const sizeMap = {
  sm: 'small',
  md: 'default',
  lg: 'large',
} as const

export const Spinner = ({
  size = 'md',
  color = 'primary',
  label,
  className = '',
  ...rest
}: SpinnerProps) => {
  const spinSize = sizeMap[size as keyof typeof sizeMap] || 'default'

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <Spin size={spinSize} {...rest} />
      {label && <span className="mt-2 text-sm text-gray-600">{label}</span>}
    </div>
  )
}

export default Spinner
